import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const MoreJobStory = (props) => {
  const { match } = props;

  return <ListStory page={Number(match.params.page)} type="jobstories" />;
};

export default MoreJobStory;
